/* Product page "See it in action" slider.
   Only rendered when the video gallery has more than three tiles; the tile
   width (three per view, 8px gap) comes from section-product-main.css so the
   row looks the same as the static layout. Swiper is only included in the
   layout on the homepage, so it's loaded on demand here (once per page), like
   assets/cart-drawer-recs.js. */

let productVideoSwiperLoader;

function loadProductVideoSwiper(jsUrl, cssUrl) {
  if (typeof Swiper !== 'undefined') return Promise.resolve();
  if (productVideoSwiperLoader) return productVideoSwiperLoader;

  productVideoSwiperLoader = new Promise((resolve, reject) => {
    if (cssUrl && !document.querySelector(`link[href="${cssUrl}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      document.head.appendChild(link);
    }

    const script = document.createElement('script');
    script.src = jsUrl;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return productVideoSwiperLoader;
}

class ProductVideoSlider extends HTMLElement {
  connectedCallback() {
    loadProductVideoSwiper(this.dataset.swiperJs, this.dataset.swiperCss)
      .then(() => this.init())
      .catch((e) => console.error(e));
  }

  disconnectedCallback() {
    this.details?.removeEventListener('toggle', this.onToggle);
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  init() {
    if (this.swiper || !this.isConnected) return;

    this.swiper = new Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      on: {
        // Don't leave a tile's video playing once it's swiped fully out of view.
        slideChangeTransitionEnd: () => this.pauseHiddenVideos(),
      },
    });

    // The accordion may be closed at init (zero width); resize once it opens.
    this.details = this.closest('details');
    this.onToggle = () => this.swiper?.update();
    this.details?.addEventListener('toggle', this.onToggle);
  }

  pauseHiddenVideos() {
    const bounds = this.getBoundingClientRect();
    this.querySelectorAll('video').forEach((video) => {
      const rect = video.getBoundingClientRect();
      const hidden = rect.right <= bounds.left + 1 || rect.left >= bounds.right - 1;
      if (hidden && !video.paused) video.pause();
    });
  }
}

if (!customElements.get('product-video-slider')) {
  customElements.define('product-video-slider', ProductVideoSlider);
}
